import styled from "styled-components";

import StyledErrorBanner from "features/shared/components/banners/styles/StyledErrorBanner.styled";
import StyledLocalLink from "features/shared/components/link/styles/StyledLocalLink.styled";
import Container from "features/shared/styles/container/Container.styled";
import PageHeader from "features/shared/styles/page-header/PageHeader.styled";

const DetailsContainer = styled(Container)`
  padding: 24px 0;

  ${StyledLocalLink}, ${StyledErrorBanner} {
    margin-bottom: 24px;
  }

  ${PageHeader} {
    margin-bottom: 24px;
  }
`;

export default DetailsContainer;
